<template>
  <div>
    <div class="dashboard_tabs">
      <ul>
        <li :class="{'active': selectedDashTab === 'Todos'}" @click="selectedDashTab = 'Todos'"><a>To-Dos</a></li>
        <li :class="{'active': selectedDashTab === 'Messages'}" @click="selectedDashTab = 'Messages'"><a>Messages</a></li>
        <li :class="{'active': selectedDashTab === 'Updates'}" @click="selectedDashTab = 'Updates'"><a>Updates</a></li>
        <li :class="{'active': selectedDashTab === 'Industry News'}" @click="selectedDashTab = 'Industry News'"><a>Industry News</a></li>
      </ul>
    </div>
    
    <template v-if="selectedDashTab === 'Industry News'">
      <dashboardNews/>
    </template>
    <template v-else-if="selectedDashTab == 'Updates'">
    <dashboardUpdates />
    </template>
    <template v-else-if="selectedDashTab == 'Messages'">
      <messages/>
    </template>
    <template v-else-if="selectedDashTab == 'Todos'">
      <dashboardToDos/>
    </template>
  </div>
</template>
    <script>
    
  
    import { _ } from 'core-js'
    import Vue from 'vue';
    Vue.use( CKEditor );
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import dashboardNews from "./dashboardNews.vue";
    import dashboardUpdates from "./dashboardUpdates.vue";
    import messages from "./messages.vue";
    import dashboardToDos from "./dashboardToDos.vue";
    export default {
      components: {
        dashboardNews,
        dashboardUpdates,
        messages,
        dashboardToDos
      },
      data: function () {
        return {
         
          selectedDashTab:'Todos',
        
        };
      },
      
      computed: {
        
       
     },
    
    methods:{

    },
      created() {
       
      },
      mounted() {
      // console.log('mounted')
      },
      
    };
    </script>
    
    